import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { RaisedButton } from "material-ui";
import { } from "../../Global/actions";
import styles from "../../styles/styles";


class InfoSE extends React.Component {
  componentWillMount() {
  }

  render() {
    return (
      <div style={styles.frameContenidoGeneral}>
        <div className="row" style={{ paddingBottom: 0 }}>
          <div className="contenido" style={{ margin: 0, padding: 0, width: 925 }}>
            <br></br>
            <div style={styles.h3}>
              Rut Institución: {this.props.rutInstitucion}&nbsp;&nbsp;
                    Nombre Institución: {this.props.nombreInstitucion}
            </div>
            <br></br>
            <div style={styles.h2}>
              <span style={{ display: "block" }}>
                Esta opción le permite actualizar un arancel de forma masiva,&nbsp;
                adjuntando un archivo excel en formato definido por la isapre.
              </span>
              <span style={{ display: "block" }}>
                Para hacer esto, debe seguir las siguientes <strong style={{ textDecoration: "underline" }}>instrucciones:</strong>
              </span>
              <br></br>
              <ul style={{ listStyle: "decimal" }}>
                <li>
                  Buscar prestaciones cargadas según los filtros presionando el botón <strong style={{ textDecoration: "underline" }}>Buscar.</strong>
                </li>
                <li>
                  Existen dos opciones para descargar archivo Excel con las prestaciones cargadas.
                  <ul style={{ listStyle: 'lower-alpha' }}>
                    <li>
                      Descargar archivo Excel con prestaciones cargadas según los filtros seleccionados presionando el botón <strong style={{ textDecoration: "underline" }}>Descargar Resultado.</strong>                    </li>
                    <li>
                      Descargar archivo Excel con la totalidad de prestaciones cargadas presionando el botón <strong style={{ textDecoration: "underline" }}>Descargar Arancel Completo.</strong>
                    </li>
                  </ul>
                </li>
                <li>
                  Las acciones que se pueden realizar son <strong>Agregar (A)</strong>, <strong>Modificar (M)</strong> y/o <strong>Eliminar (E)</strong> prestaciones.
                  Para esto se debe ingresar las letras <strong>A</strong>, <strong>M</strong> ó <strong>E</strong> en la columna Acción, respectivamente. Todas aquellas prestaciones que
                  no requieran ninguna acción deben ser <strong>borradas</strong> del archivo excel descargado.
                </li>
                <li>
                  El nombre de las columnas puede tener la sigla (*) más las letras A, M ó E. Esto indica <strong>obligatoriedad</strong> de la columna para cada acción.
                  <ul style={{ listStyle: 'lower-alpha' }}>
                    <li>
                      Para <strong>Agregar</strong> prestaciones, se debe completar las columnas obligatorias <strong>(*A)</strong> e ingresar la letra "A" en la columna Acción.
                      Debe descargar el archivo con nuestras glosas presionando el botón <strong style={{ textDecoration: 'underline' }}>Glosas</strong> y copiar nuestras glosas tal como
                      se indican en dicho archivo.
                    </li>
                    <li>
                      Para <strong>Modificar</strong> prestaciones, se debe ingresar nueva <strong>Fecha Inicio Vigencia Precio</strong>, nuevo <strong>Valor</strong>, <strong>Unidad</strong> e
                      ingresar la letra "M" en la columna Acción.
                    </li>
                    <li>
                      Para <strong>Eliminar</strong> prestaciones, se debe indicar <strong>Fecha Término Vigencia Precio</strong> e ingresar la letra "E" en la columna Acción.
                    </li>
                  </ul>
                </li>
                <li>
                  Cargar el archivo Excel presionando el botón <strong style={{ textDecoration: 'underline' }}>Cargar Solicitud</strong>.
                </li>
                <li>
                  Se validará el archivo enviado. Podrá ver el resultado de la validación en <strong>"Archivos Enviados"</strong>, columna <strong>"Detalle"</strong>.
                    <ul style={{ listStyle: 'lower-alpha' }}>
                    <li>
                      Si el archivo Excel se cargó correctamente, podrá revisar el estado de su solicitud en el menú <strong>"Solicitudes Realizadas"</strong>.
                    </li>
                  </ul>
                </li>
              </ul>
              <br></br>
              Una vez enviada la solicitud, la isapre la revisará, aprobándola o rechazándola.&nbsp;
              La respuesta a la solicitud será notificada electrónicamente a su email de contacto.&nbsp;
              Además podrá revisar el estado de sus solicitudes enviadas en la opción&nbsp;
              &quot;Solicitudes realizadas&quot;
            </div>
            <br></br>
            <div style={styles.h1}>Email de contacto</div>
            <div style={styles.h2}>
              Las notificaciones se realizarán a la siguiente dirección de correo electrónico:&nbsp;
              <strong>{this.props.datosUsuario.mail}</strong><br />
              Si desea modificar el email de contacto, debe cambiarlo en la sección &quot;Datos del Prestador&quot;
            </div>
            <br></br>
            <div style={styles.h1}>Prestaciones Cargadas</div>
            <div style={styles.h2}>
              Seleccione el centro de atención y tipo de arancel que desea consultar.
              Además, si desea buscar una prestación en particular, puede adicionar a la búsqueda
              el filtro por código del prestador o fonasa.
            </div>
            <div style={styles.h3}>Rut Institución: {this.props.rutInstitucion}
            </div>
            <br></br>
          </div>

        </div>

      </div>
    );
  }
}

InfoSE.defaultProps = {
};

InfoSE.propTypes = {
  rutInstitucion: PropTypes.number.isRequired,
  nombreInstitucion: PropTypes.string.isRequired,
  datosUsuario: PropTypes.any.isRequired,
  // dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  rutInstitucion: state.global.rutInstitucion,
  nombreInstitucion: state.global.nombreInstitucion,
  datosUsuario: state.global.datosUsuario,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});


export default connect(mapStateToProps, mapDispatchToProps)(InfoSE);



// WEBPACK FOOTER //
// ./src/components/SolicitudesEspeciales/FiltroBusqueda/info.jsx